import { render } from "./MathCaptchaField.vue?vue&type=template&id=d86d75dc"
import script from "./MathCaptchaField.vue?vue&type=script&lang=js"
export * from "./MathCaptchaField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__